export function set(key, value) {
    return (dispatch) => {
        dispatch({type: key, value: value})
    }
}

export function clear(key) {
    return (dispatch) => {
        dispatch({type: key, value: undefined})
    }
}

